import React, { useEffect, useState } from "react";
import moment from "jalali-moment";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// import {BottomSheet} from "react-spring-bottom-sheet";
import { useTranslation, Trans } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeadingSecondary from "../components/HeadingSecondary";
import Proof from "../components/ProofOfVaccination";
import { ReactComponent as Info } from "../assets/images/information.svg";
import VaccineDoses from "../components/VaccineDoses";
import { useLocalStorage } from "../hooks/useLocalStorage";
import { getToken } from "../helper/helper";
import { IPassportInfo } from "../models/passport.model";
import i18n from "../i18n";
import profileService from "../services/profile.service";
import vaccineService from "../services/vaccination.service";
import Spinner from "../components/Spinner";
import DotLoading from "../components/DotLoading";
import userService from "../services/profile.service";
import ProfileNotification from "../components/ProfileNotification";

const VaccineLicense = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  // const [showAlert, setShowAlert] = useState(false);
  // const [showConfirm, setShowConfirm] = useState(false);

  let [schema] = useState(
    yup.object().shape({
      passportNumber: yup
        .string()
        .required("لطفا فیلد مورد نظر را پر کنید")
        .matches(/^[a-z,A-Z]{1}(\d){8}$/, "فرمت شماره گذرنامه اشتباه است ."),
      birthDate: yup.string().required("لطفا فیلد مورد نظر را پر کنید"),
      nationalId: yup.string().required("لطفا فیلد مورد نظر را پر کنید"),
      englishName: yup
        .string()
        .required("لطفا فیلد مورد نظر را پر کنید")
        .matches(/[a-z,A-Z]$/, "فرمت نام اشتباه است."),
      englishLastName: yup
        .string()
        .required("لطفا فیلد مورد نظر را پر کنید")
        .matches(/[a-z,A-Z]$/, "فرمت نام خانوادگی اشتباه است."),
    })
  );

  const notify = (text: string) => {
    toast(<ProfileNotification text={text} />, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      closeButton: false,
      progress: undefined,
    });
  };

  const [submitted, setSubmitted] = useLocalStorage<IPassportInfo>("passport-info", {
    passportNumber: "",
    firstName: "",
    lastName: "",
  });

  const [errorsMsg, setErrorsMsg] = useState([]) as any;

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    // fetchProfile();
    const userInfo = getToken();
    const birthDate = userInfo.birthDate;
    setValue(
      "birthDate",
      birthDate.slice(0, 4) + "/" + birthDate.slice(4, 6) + "/" + birthDate.slice(6)
    );
    setValue("nationalId", userInfo.nationalId);
    // eslint-disable-next-line
  }, []);

  // async function fetchProfile() {
  //   setLoading(true);
  //
  //   try {
  //     const {data} = await profileService.getUserInfo();
  //     const birthDate = data.birthDate;
  //     const birthDateFormat = birthDate.slice(0, 4) + "/" + birthDate.slice(4, 6) + "/" + birthDate.slice(6);
  //     setValue("birthDate", birthDateFormat);
  //     setValue(
  //       "birthDateGregorian",
  //       moment.from(data.birthDate, "fa", "YYYYMMDD").format("YYYYMMDD")
  //     );
  //     setValue("nationalId", data.username);
  //   } catch (error: any) {
  //     if (error.response) {
  //       // Request made and server responded
  //       if (error.response.status === 401) {
  //         console.log("profile refresh token call");
  //         // refreshToken();
  //         logOut();
  //       }
  //
  //       if (error.response.status === 400) {
  //         logOut();
  //       }
  //     } else if (error.request) {
  //       console.log("The request was made but no response was received");
  //     } else {
  //       // Something happened in setting up the request that triggered an Error
  //       console.log("Error", error.message);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  const [vaccinationCardInfo, setVaccinationCardInfo] = useState([]);
  const [issueDate, setIssueDate] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [loadingVaccine, setLoadingVaccine] = useState(false);
  const [showCard, setShowCard] = useState(false);
  const [ierror, setIerror] = useState(null) as any;
  const [isLoading, setIsLoading] = useState(false);
  const [loadingGetProfile, setLoadingGetProfile] = useState(false);

  const getInternationalVaccinationCard = async () => {
    setLoadingVaccine(true);
    try {
      // eslint-disable-next-line
      setShowCard(true);
      const { data } = await vaccineService.getInternationalVaccinationCard();
      setIssueDate(data.issueDate);
      setQrCode(data.qrCode);
      const vaccinationCard = data.vaccinationInfos;
      // const temp: any = [{}, {}, {}];
      // vaccinationCard.forEach((item: any, index: any) => {
      //   return temp.fill(item, index, ++index);
      // });
      setVaccinationCardInfo(vaccinationCard);
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 412) {
          return setShowCard(false);
        }
        if (error.response.status >= 500) {
          notify("Internal Server Error");
          setErrorsMsg([{ field: "", message: "Something went wrong!" }]);
        }
        // console.log(error.response.data);
        console.log(error.response.status);
        // console.log(error.response.headers);
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        setErrorsMsg([{ field: "", message: "Something went wrong!" }]);
      }
    } finally {
      setLoadingVaccine(false);
    }
  };

  const getBasicUserInfo = async () => {
    setLoadingGetProfile(true);
    try {
      const { data } = await userService.getUserInfo();
      if (data.passportNumber && data.passportNumber !== "") {
        getInternationalVaccinationCard();
        setSubmitted({
          passportNumber: data.passportNumber,
          firstName: data.englishFirstName,
          lastName: data.englishLastName,
        });
        return null;
      }
      setShowCard(false);
    } catch (error: any) {
      if (error.response) {
        console.log(error.response);
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    } finally {
      setLoadingGetProfile(false);
    }
  };

  useEffect(() => {
    getBasicUserInfo();
  }, []);

  async function onSubmit(values: any) {
    setLoading(true);
    const finalDate = {
      englishFirstName: values.englishName,
      englishLastName: values.englishLastName,
      passportNumber: values.passportNumber,
    };
    try {
      // eslint-disable-next-line
      const result = await profileService.savePassport(finalDate);
      if (result.status === 201) {
        setSubmitted({
          passportNumber: values.passportNumber,
          firstName: values.englishName,
          lastName: values.englishLastName,
        });
        result && (await getInternationalVaccinationCard());
        setShowCard(true);
      }
    } catch (error: any) {
      if (error.response) {
        // console.log(error.response.data);
        if (error.response.status === 412) {
          setIerror("ورودی ها نامعتبر است.");
        }
        console.log(error.response.status);
        // console.log(error.response.headers);
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    } finally {
      setLoading(false);
    }

    // if (!showAlert) {
    //   setSchema(
    //     yup.object().shape({
    //       passportNumber: yup
    //         .string()
    //         .required("لطفا فیلد مورد نظر را پر کنید")
    //         .matches(
    //           /^[a-z,A-Z]{1}(\d){8}$/,
    //           "فرمت شماره گذرنامه اشتباه است ."
    //         ),
    //       birthDate: yup.string().required("لطفا فیلد مورد نظر را پر کنید"),
    //       nationalId: yup.string().required("لطفا فیلد مورد نظر را پر کنید"),
    //       englishName: yup
    //         .string()
    //         .required("لطفا فیلد مورد نظر را پر کنید")
    //         .matches(/[a-z,A-Z]$/, "فرمت نام و نام خانوادگی اشتباه است."),
    //       gender: yup
    //         .mixed()
    //         .required("لطفا فیلد مورد نظر را پر کنید")
    //         .oneOf(["male", "female"], "لطفا یکی از موارد را انتخاب کنید"),
    //       birthDateGregorian: yup
    //         .number()
    //         .required("لطفا فیلد مورد نظر را پر کنید"),
    //     })
    //   );
    //
    //   toast.error(
    //     <div className="u-d-flex u-align-item-center">
    //       <InformationDanger/>
    //       <span className="u-margin-right-small-1">
    //         اطلاعاتی از واکسیناسیون شما ثبت نشده است.
    //       </span>
    //     </div>,
    //     {
    //       position: "top-center",
    //       autoClose: 2000,
    //       hideProgressBar: true,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       progress: undefined,
    //     }
    //   );
    //   setShowAlert(true);
    // } else {
    //   setShowConfirm(true);
    //   setSubmitted({
    //     ...values,
    //     issuedDate: moment(new Date()).locale("fa").format("YYYYMMDD"),
    //   });
    // }
  }

  // const onConfirm = () => {
  //   setShowConfirm(false);
  //   setSubmitted({
  //     ...submitted,
  //     confirm: true,
  //   });
  // };

  return (
    <>
      <ToastContainer rtl />
      {/*<BottomSheet open={showConfirm}>*/}
      {/*  <div className="vaccine-license">*/}
      {/*    <div*/}
      {/*      className="u-margin-top-small-3 u-margin-bottom-small-3"*/}
      {/*      style={{padding: "0 6rem"}}*/}
      {/*    >*/}
      {/*      <div className="u-d-flex-column u-justify-content-center text-center text-xl">*/}
      {/*        <Caution*/}
      {/*          style={{width: "64px", height: "64px", margin: "auto"}}*/}
      {/*          className="u-margin-bottom-small-3"*/}
      {/*        />*/}
      {/*        <p>*/}
      {/*          آیا این اطلاعات عینا برابر با مندرجات گذرنامه معتبر شما است؟*/}
      {/*        </p>*/}
      {/*      </div>*/}
      {/*      <div className="u-d-flex-column u-justify-content-center u-margin-top-small-3 ltr">*/}
      {/*        <div className="u-d-flex justify-between border-b border-gray-100">*/}
      {/*          <span className="text-gray-500 text-xl">Passport Number:</span>*/}
      {/*          <span>{submitted.passportNumber}</span>*/}
      {/*        </div>*/}
      {/*        <div className="u-d-flex justify-between border-b border-gray-100 pt-2">*/}
      {/*          <span className="text-gray-500 text-xl">Name:</span>*/}
      {/*          <span>{submitted.englishName}</span>*/}
      {/*        </div>*/}
      {/*        <div className="u-d-flex justify-between border-b border-gray-100 pt-2">*/}
      {/*          <span className="text-gray-500 text-xl">Date of birth:</span>*/}
      {/*          <span>*/}
      {/*            /!* {submitted.birthDateGregorian} *!/*/}
      {/*            {`${submitted.birthDateGregorian || "-"}`.replace(*/}
      {/*              /(\d{4})(\d{2})(\d{2})/g,*/}
      {/*              "$1/$2/$3"*/}
      {/*            )}*/}
      {/*          </span>*/}
      {/*        </div>*/}
      {/*        <div className="u-d-flex justify-between border-b border-gray-100 pt-2">*/}
      {/*          <span className="text-gray-500 text-xl">Gender:</span>*/}
      {/*          <span>{capitalizeFirstLetter(submitted.gender || "-")}</span>*/}
      {/*        </div>*/}
      {/*      </div>*/}

      {/*      <div className="u-d-flex u-justify-content-center u-margin-top-small-3">*/}
      {/*        <button*/}
      {/*          type="button"*/}
      {/*          className="btn btn--primary shadow-0 u-width-100"*/}
      {/*          onClick={() => setShowConfirm(false)}*/}
      {/*        >*/}
      {/*          خیر*/}
      {/*        </button>*/}
      {/*        <button*/}
      {/*          type="button"*/}
      {/*          className="btn btn--outline u-margin-right-small-1 u-width-100"*/}
      {/*          onClick={onConfirm}*/}
      {/*        >*/}
      {/*          بله*/}
      {/*        </button>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*</BottomSheet>*/}
      <div className="vaccine-license">
        {showCard ? (
          loadingVaccine ? (
            <div className="u-margin-top-big">
              <Spinner />
            </div>
          ) : (
            <div className={`proof-of-vaccination-wrapper ${i18n.dir()}`}>
              <Proof.ProofOfVaccination>
                <Proof.OwnerSectionTop qrCode={qrCode} errors={errorsMsg} />
                <Proof.OwnerSectionMiddle />
                <Proof.OwnerSectionBottom issueDate={issueDate} />
              </Proof.ProofOfVaccination>

              <div className="vaccination-detail-wrapper">
                <h4 className="title">{t("Vaccination")}</h4>

                {vaccinationCardInfo.length
                  ? vaccinationCardInfo.map((info: any, i: any) => {
                      return <VaccineDoses index={i} key={i} data={info} />;
                    })
                  : null}

                <div className="vaccination-detail-card notice text-xl">
                  <div className="pb-5 text-gray-600">
                    <Trans i18nKey="pages__vaccine__description">
                      {/* eslint-disable-next-line */}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-navy-900 text-decoration-underline"
                        href="https://health.gov.ir"
                      />
                    </Trans>
                  </div>
                  <div>
                    <span>{t("pages__vaccine__note")}</span>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className=""
                      href="https://vaccine.health.gov.ir"
                    >
                      https://vaccine.health.gov.ir
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : loadingGetProfile ? (
          <div className="u-margin-top-big">
            <Spinner />
          </div>
        ) : (
          <div className="proof-of-vaccination">
            <div className="u-margin-top-small-3-5 u-margin-bottom-small-2">
              <HeadingSecondary text="واکسیناسیون" />
            </div>
            <div className="w-full text-right">
              <div>
                <h4 className="u-font-1-4 u-margin-bottom-small-1-2">
                  درخواست گواهی بین‌المللی واکسیناسیون
                </h4>
                <p className="text-xl text-gray-500 u-font-1 u-margin-bottom-small-1-2">
                  در این بخش از طریق ورود شماره گذرنامه خود میتوانید گواهی واکسیناسیون بین‌المللی
                  خود را دریافت فرمایید.
                </p>
                <a href="/#" className="u-d-flex text-lg  text-navy-900 items-center">
                  <Info />
                  <span className="mr-2 u-font-1-1">برای دریافت اطلاعات بیشتر کلیک کنید.</span>
                </a>

                <form
                  className="u-margin-bottom-big-6-5 u-d-flex flex-column"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="u-margin-bottom-big-6-5 u-d-flex flex-column">
                    <>
                      <div className="input-holder relative u-margin-top-medium-5">
                        <label className="absolute overlay-lable u-color-grey-light-10 u-font-1-1">
                          شماره گذرنامه
                        </label>
                        <input
                          type="text"
                          className={`ltr bg-white ${errors.passportNumber ? "input-error" : ""}`}
                          {...register("passportNumber")}
                          name="passportNumber"
                          placeholder="J00000000"
                          autoComplete="off"
                          defaultValue={submitted.passportNumber}
                        />
                        {errors.passportNumber && (
                          <span className="error-box u-margin-top-small-1">
                            <p className="error-box__content">{errors.passportNumber.message}</p>
                          </span>
                        )}
                      </div>

                      <div className="input-holder relative u-margin-top-small-1">
                        <label className="absolute overlay-lable u-color-grey-light-10 u-font-1-1">
                          نام <span className="u-red">(انگلیسی)</span>
                        </label>
                        <input
                          type="text"
                          className={`ltr bg-white ${errors.englishName ? "input-error" : ""}`}
                          {...register("englishName")}
                          name="englishName"
                          placeholder="Ali"
                          autoComplete="off"
                          defaultValue={submitted.firstName}
                        />
                        {errors.englishName && (
                          <span className="error-box u-margin-top-small-1">
                            <p className="error-box__content">{errors.englishName.message}</p>
                          </span>
                        )}
                      </div>

                      <div className="input-holder relative u-margin-top-small-1">
                        <label className="absolute overlay-lable u-color-grey-light-10 u-font-1-1">
                          نام خانوادگی <span className="u-red">(انگلیسی)</span>
                        </label>
                        <input
                          type="text"
                          className={`ltr bg-white ${errors.englishLastName ? "input-error" : ""}`}
                          {...register("englishLastName")}
                          name="englishLastName"
                          placeholder="Hashemi"
                          autoComplete="off"
                          defaultValue={submitted.lastName}
                        />
                        {errors.englishLastName && (
                          <span className="error-box u-margin-top-small-1">
                            <p className="error-box__content">{errors.englishLastName.message}</p>
                          </span>
                        )}
                      </div>
                    </>

                    <div className="input-holder relative u-margin-top-small-1">
                      <label className="absolute overlay-lable u-color-grey-light-10 u-font-1-1">
                        تاریخ تولد
                      </label>

                      <input
                        className={`ltr bg-white u-color-grey-dark-main-5 u-font-1-6 ${
                          errors.birthDate ? "input-error" : ""
                        }`}
                        type="text"
                        disabled={true}
                        placeholder="1397/09/03"
                        {...register("birthDate")}
                        readOnly
                      />
                      {errors.birthDate && (
                        <span className="error-box u-margin-top-small-1">
                          <p className="error-box__content">{errors.birthDate.message}</p>
                        </span>
                      )}
                    </div>

                    <div className="input-holder relative u-margin-top-small-1">
                      <label className="absolute overlay-lable u-color-grey-light-10 u-font-1-1">
                        کدملی
                      </label>
                      <input
                        className={`ltr bg-white u-color-grey-dark-main-5 u-font-1-6 ${
                          errors.nationalId ? "input-error" : ""
                        }`}
                        {...register("nationalId")}
                        name="nationalId"
                        placeholder="00000000000"
                        autoComplete="off"
                        disabled={true}
                        type="text"
                        readOnly
                      />
                      {errors.nationalId && (
                        <span className="error-box u-margin-top-small-1">
                          <p className="error-box__content">{errors.nationalId.message}</p>
                        </span>
                      )}
                    </div>

                    <div className="error-box u-margin-top-small-1">
                      {ierror && <p className="error-box__content">{ierror}</p>}
                    </div>
                  </div>
                  <button type="submit" disabled={loading} className="btn btn--primary u-width-100">
                    {!loading ? "ثبت" : <DotLoading />}
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default VaccineLicense;
